var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SGPRowComponent',{attrs:{"no-gutters":""}},[_c('SGPColComponent',{attrs:{"cols":"12"}},[_c('label',[_vm._v(_vm._s(_vm.regional))])])],1),_c('hr')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }